import { NativeSignVo } from "@/api/native/types";
import store from "@/store";

// 旧银河支付宝签约-入参
export const alipayOptions: NativeSignVo = {
  token: store.state.base.originUserInfo.token,
  sceneType: "FINANCE",
  aliPayReturnUrl: "hellobike://hellobike.com/sign_wallet_alipayWithhold",
  businessType: "26",
  signChannel: "alipay",
  actionOrigin: "RepaymentSign",
  creditModel: "normal",
  memo: "",
};
